import { Page } from "@/types/Page";
import DokumenteService from "./DokumenteService";
import {
  Massnahme,
  OverviewMassnahme,
  MassnahmenFilter,
} from "@/types/Massnahme";

class MassnahmenService extends DokumenteService {
  constructor() {
    super("/massnahme");
  }

  /**
   * @param id Massnahmen Id
   */
  public getMassnahme(id: number | string): Promise<Massnahme> {
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() => this.requestService.get<Massnahme>(this.root + `/${id}`));
  }

  /**
   * @param id Massnahmen Id
   * @param massnahme Massnahme object
   */
  public updateMassnahme(
    id: number | string,
    massnahme: Massnahme,
  ): Promise<Massnahme> {
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() =>
        this.requestService.post<Massnahme>(this.root + `/${id}`, massnahme),
      );
  }
  /**
   * @param massnahme Massnahme data
   */
  public createMassnahme(massnahme: Massnahme): Promise<Massnahme> {
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() =>
        this.requestService.put<Massnahme>(this.root + `/`, massnahme),
      );
  }

  /**
   * @param id Massnahmen Id
   */
  public deleteMassnahme(id: number | string | null): Promise<void> {
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() => this.requestService.delete<void>(this.root + `/${id}`));
  }

  public deleteMassnahmen(
    agKommune: number | string,
    massnahmen: OverviewMassnahme[],
  ): Promise<OverviewMassnahme[]> {
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() =>
        this.requestService.post<OverviewMassnahme[]>(
          this.root + `/byAgKommune/${agKommune}`,
          massnahmen,
        ),
      );
  }

  //----- Search ------
  public getPage(
    page: number,
    size?: number,
    sort?: string,
    ascending?: boolean,
    filter?: MassnahmenFilter,
  ): Promise<Page<OverviewMassnahme>> {
    const params = {
      page,
      size,
      sort,
      ascending,
      filter,
    };
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() =>
        this.requestService.post<Page<OverviewMassnahme>>(
          this.root + `/search`,
          params,
        ),
      );
  }

  public getByKommune(
    agKommune: number | string,
  ): Promise<Array<OverviewMassnahme>> {
    return this.authService
      .checkAuthentication()
      .then(() =>
        this.requestService.get<Array<OverviewMassnahme>>(
          this.root + `/byAgKommune/${agKommune}`,
        ),
      );
  }
  /**
   *@param filter filter object
   */
  public getExport(filter?: MassnahmenFilter): Promise<Blob> {
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() =>
        this.requestService.postDownload<any>(this.root + `/export`, filter),
      )
      .then((res: Blob) => {
        return res;
      });
  }
}

const massnahmenServiceInstance = new MassnahmenService();

export { massnahmenServiceInstance };
export default MassnahmenService;
